import React from 'react';
import PropTypes from 'prop-types';
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';
import GeneralHelpers from 'lib/helpers/GeneralHelpers';

const PaymentSchedule = ({ contract, currencySymbol }) => (
  <div>
    <h3>PAYMENT SCHEDULE:</h3>
    <div style={{ marginTop: 10 }}>
      {contract.invoices.map((invoice, i) => (
        <div key={invoice._id}>
          <p>
            {`[${i + 1}]`} Invoice for {CurrencyHelpers.centsToDollars(invoice.amount, { symbol: currencySymbol })} due{' '}
            {GeneralHelpers.formatDate(invoice.due)}
          </p>
        </div>
      ))}
    </div>
  </div>
);

PaymentSchedule.propTypes = {
  contract: PropTypes.object,
};

// Specifies the default values for props:
PaymentSchedule.defaultProps = {
  contract: {},
};

export default PaymentSchedule;



// WEBPACK FOOTER //
// ./src/components/common/ContractComponent/ServicesAndPayment/PaymentSchedule/index.js